import { UserModel } from './user-model';
import { ContractModel } from './contract-model';
import { GDSCredentials } from './gds-credentials-model';

export interface CustomerModel {
  CustomerId: number,
  Name: string,
  Enabled: boolean,
  RequiresAuditApproval: boolean,
  RerunLogicActive: boolean,
  XxyyzzActive: boolean,
  AmadeusThreads: number,
  ApolloThreads: number,
  GalileoThreads: number,
  SabreThreads: number,
  WorldspanThreads: number,
  NumberofConcurrentJobs: number,
  DetailReportDir: string,
  CompletedDir: string,
  DetailReportVirtualDir: string,
  ParentCustomerID: number
  InboxLocation: string,
  HotelChain: boolean,
  BARKeywords: string,
  UserList: UserModel[],
  Contract?: ContractModel,
  GDSSecurityCredentials?: GDSCredentials,
  ChainCodes: string[],
  ComparisonKeywords: string,
  CustomerType: string,
  CustomerName: string,
  QuickAudit: boolean,
  SabreAAAPCC: string,
  ChannelID: number,
  ClientID: number,
  CustomerNumber: string
};

export function initCustomerModel(): CustomerModel {
  return {
    CustomerId: 0,
    Name: "",
    Enabled: true,
    RequiresAuditApproval: false,
    RerunLogicActive: false,
    XxyyzzActive: false,
    AmadeusThreads: 25,
    ApolloThreads: 25,
    GalileoThreads: 25,
    SabreThreads: 25,
    WorldspanThreads: 25,
    NumberofConcurrentJobs: 1,
    DetailReportDir: '',
    CompletedDir: '',
    DetailReportVirtualDir: '',
    ParentCustomerID: 0,
    InboxLocation: '',
    HotelChain: false,
    BARKeywords: '',
    UserList: [],
    ChainCodes: [],
    ComparisonKeywords: "",
    CustomerType: "",
    CustomerName: "",
    QuickAudit: false,
    SabreAAAPCC: "",
    ChannelID: 0,
    ClientID: 0,
    CustomerNumber: ""
  };
}
